import React from 'react';
import { JSX } from 'react/jsx-runtime';

const FuelIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1031 4.15332H5.28437C4.92812 4.15332 4.60156 4.44563 4.60156 4.82563V8.80101C4.60156 9.15178 4.89844 9.47332 5.28437 9.47332H11.1031C11.4594 9.47332 11.7859 9.18101 11.7859 8.80101V4.82563C11.7562 4.44563 11.4594 4.15332 11.1031 4.15332ZM10.4203 8.15794H5.9375V5.4687H10.4203V8.15794Z"
        fill="#EEF7FF"
      />
      <path
        d="M18.6436 6.28755L16.3873 4.06602C16.1201 3.80294 15.7045 3.80294 15.4373 4.06602C15.1701 4.32909 15.1701 4.73832 15.4373 5.0014L16.3576 5.90755V7.95371C16.3576 8.30448 16.6545 8.62602 17.0404 8.62602H17.4857V13.0399H16.0311V9.50294C16.0311 9.15217 15.7342 8.83063 15.3482 8.83063H13.7451V4.00755C13.7451 3.01371 12.9139 2.16602 11.8748 2.16602H4.45293C3.44355 2.16602 2.58262 2.98448 2.58262 4.00755V16.6645H1.6623C1.30605 16.6645 0.979492 16.9568 0.979492 17.3368C0.979492 17.7168 1.27637 18.0091 1.6623 18.0091H14.6357C14.992 18.0091 15.3186 17.7168 15.3186 17.3368C15.3186 16.9568 15.0217 16.6645 14.6357 16.6645H13.7154V10.1752H14.6654V13.7122C14.6654 14.0629 14.9623 14.3845 15.3482 14.3845H18.1389C18.4951 14.3845 18.8217 14.0922 18.8217 13.7122V6.75525C18.8217 6.57986 18.7623 6.40448 18.6436 6.28755ZM3.94824 16.6645V4.00755C3.94824 3.71525 4.18574 3.4814 4.48262 3.4814H11.9045C12.2014 3.4814 12.4389 3.71525 12.4389 4.00755V16.6645H3.94824Z"
        fill="#EEF7FF"
      />
    </svg>
  );
};

export default FuelIconDark;
